export default __webpack_public_path__ + "static/media/logs_1.1209f51c.png";